export default __webpack_public_path__ + "static/media/ICONOS INGLÉS  MI SEGURO SOMIT -18.b129add0.png";